// extracted by mini-css-extract-plugin
module.exports = {"modal":"BalanceModal_modal__1Bt7n","active":"BalanceModal_active__RqyiP"};